module.exports = __webpack_public_path__ + "media/assets/bullet_green_tick-c7953d49.svg";